<template>
  <div>
    <NavigationBar />
    <h1>User Poems</h1>
    <p>Details about the user poems.</p>
  </div>
</template>

<script>
import NavigationBar from './NavigationBar.vue';
export default {
  name: 'UserPoems',
  components: { 
    NavigationBar
  }
};
</script>

